var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" }, props),
    React.createElement(
      "g",
      { fill: "#ccc" },
      React.createElement("path", { d: "M37.5 12.55v4h-8.36v2.06l-8.48-4.1 8.48-4.1v2.14h8.36zM4.71 18.19v5.11h9.87v2.63l10.01-5.24-10.01-5.24v2.74H4.71zM37.5 25.11v4h-8.36v2.06l-8.48-4.1 8.48-4.1v2.14h8.36z" })
    )
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Matching.svg